import { request } from './client';

export function getPickStats(gameId, gameWeek) {
  return request(`/api/customer/games/${gameId}/gameweek/${gameWeek}/pick-stats`);
}

export function getEliminationStats(gameId, gameWeek) {
  return request(`/api/customer/games/${gameId}/gameweek/${gameWeek}/elimination-stats`);
}
